<template>
  <section class="cookies"  id="start">
    <div class="container">

      <!-- Header -->
      <div class="cookies-header anim-item">
        <div class="badge">
          <i class="bi bi-cookie"></i>
          Política de Cookies
        </div>
        <h1 class="cookies-title">Política de Cookies</h1>
        <p class="cookies-meta">
          <i class="bi bi-building"></i> GST – Gestión Servicio Técnico
          <span class="dot">·</span>
          <i class="bi bi-envelope-fill"></i> contacto@gst.com.co
          <span class="dot">·</span>
          <i class="bi bi-calendar3"></i> Última actualización: Marzo 2026
        </p>
        <p class="cookies-intro">
          Nuestra Política de Cookies explica cómo usamos las cookies y tecnologías similares
          para reconocerte cuando visitas nuestra plataforma. Al utilizarla, aceptas el uso de
          cookies como se describe a continuación.
        </p>
      </div>

      <div class="sections">

        <!-- ¿Qué son? -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-question-circle-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">¿Qué son las Cookies?</h2>
            <p>
              Las cookies son pequeños archivos de texto que las plataformas web colocan en tu
              dispositivo mientras navegas por Internet. Sirven para recordar tus preferencias,
              ayudarte a navegar de manera eficiente entre páginas y mejorar tu experiencia de
              usuario. También pueden ayudar a que la información que ves sea más relevante para
              ti y tus intereses.
            </p>
          </div>
        </div>

        <!-- Uso -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-gear-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">Uso de Cookies en Nuestra Plataforma</h2>
            <p>En GST utilizamos cookies para:</p>
            <ul class="check-list">
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Mejorar la experiencia de usuario:</strong> permiten que nuestra plataforma recuerde tus preferencias y configuraciones, como el idioma o el modo oscuro/claro.</span>
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Análisis y rendimiento:</strong> nos ayudan a entender cómo interactúan los usuarios con nuestra plataforma para mejorar el servicio.</span>
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Seguridad:</strong> algunas cookies son necesarias para proteger tu cuenta y garantizar que solo tú puedas acceder a tu información.</span>
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Publicidad:</strong> podemos usar cookies para mostrar contenido relevante a tus intereses en caso de que existan promociones o alianzas comerciales.</span>
              </li>
            </ul>
            <p>
              Las cookies utilizadas por GST <strong>no recopilan información personal sensible</strong>
              ni acceden a información almacenada fuera de la plataforma.
            </p>
          </div>
        </div>

        <!-- Tipos -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-list-ul"></i></div>
          <div class="section-body">
            <h2 class="section-title">Tipos de Cookies que Utilizamos</h2>
            <div class="type-cards">
              <div class="type-card">
                <div class="type-icon"><i class="bi bi-shield-lock-fill"></i></div>
                <div>
                  <strong>Cookies Esenciales</strong>
                  <p>Necesarias para que la plataforma funcione correctamente. Incluyen cookies que te permiten acceder a áreas seguras y mantener tu sesión iniciada.</p>
                </div>
              </div>
              <div class="type-card">
                <div class="type-icon"><i class="bi bi-bar-chart-fill"></i></div>
                <div>
                  <strong>Cookies de Rendimiento y Análisis</strong>
                  <p>Recopilan información sobre cómo los visitantes usan la plataforma, como las páginas más visitadas o los errores que puedan ocurrir.</p>
                </div>
              </div>
              <div class="type-card">
                <div class="type-icon"><i class="bi bi-sliders"></i></div>
                <div>
                  <strong>Cookies de Funcionalidad</strong>
                  <p>Te reconocen cuando regresas a la plataforma y recuerdan tus preferencias, como el modo de visualización o el plan contratado.</p>
                </div>
              </div>
              <div class="type-card">
                <div class="type-icon"><i class="bi bi-megaphone-fill"></i></div>
                <div>
                  <strong>Cookies de Publicidad</strong>
                  <p>Registran tus visitas y los enlaces que has seguido para mostrarte contenido promocional relevante.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Control -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-toggles"></i></div>
          <div class="section-body">
            <h2 class="section-title">Control de Cookies</h2>
            <p>
              Puedes controlar y gestionar las cookies de varias maneras. Ten en cuenta que
              eliminar o bloquear cookies puede afectar tu experiencia y algunas partes de la
              plataforma podrían dejar de ser completamente accesibles.
            </p>
            <ul class="check-list">
              <li>
                <i class="bi bi-browser-chrome"></i>
                <span><strong>Preferencias del navegador:</strong> la mayoría de los navegadores te permiten ver, gestionar, eliminar y bloquear cookies. Si eliminas todas las cookies, tus preferencias se perderán.</span>
              </li>
              <li>
                <i class="bi bi-person-gear"></i>
                <span><strong>Configuración de la plataforma:</strong> en GST puedes gestionar tus preferencias de cookies directamente desde el panel de configuración de tu cuenta, cuando esta funcionalidad esté disponible.</span>
              </li>
              <li>
                <i class="bi bi-tools"></i>
                <span><strong>Herramientas de terceros:</strong> existen diversas herramientas disponibles en línea para ayudarte a gestionar tus preferencias de cookies.</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- Cambios -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-arrow-repeat"></i></div>
          <div class="section-body">
            <h2 class="section-title">Cambios en la Política de Cookies</h2>
            <p>
              Podemos actualizar nuestra Política de Cookies de vez en cuando para adaptarnos a
              cambios legales o mejoras en la plataforma. Te animamos a revisar esta política
              regularmente para estar informado sobre cómo usamos las cookies.
            </p>
          </div>
        </div>

        <!-- Contacto -->
        <div class="section-card section-card--last">
          <div class="section-icon"><i class="bi bi-chat-dots-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">Contacto</h2>
            <p>Si tienes alguna pregunta sobre nuestra Política de Cookies, contáctanos a través de:</p>
            <div class="channels">
              <a href="mailto:contacto@gst.com.co" class="channel-pill"><i class="bi bi-envelope-fill"></i> contacto@gst.com.co</a>
              <a href="https://wa.me/573015739461" class="channel-pill"><i class="bi bi-whatsapp"></i> +57 301 573 9461</a>
              <a href="https://ayuda.gst.com.co" class="channel-pill"><i class="bi bi-life-preserver"></i> ayuda.gst.com.co</a>
            </div>
          </div>
        </div>

      </div>

      <!-- Footer note -->
      <div class="cookies-footer anim-item">
        <i class="bi bi-building"></i>
        <span>OPERACION SISTEMICA SAS · NIT 901227220-8 · © 2019–2026 GST. Todos los derechos reservados.</span>
      </div>

    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRoute } from 'vue-router'

defineProps({ darkMode: Boolean })

const route = useRoute()

import { onMounted, nextTick } from 'vue'
onMounted(() => {
  nextTick(() => {
    if (route.hash) {
      const id = route.hash.replace('#', '')
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ block: 'start' })
      }
    }
  })
})
</script>

<style scoped>
.cookies {
  min-height: 100vh;
  background: var(--bg);
  padding: 5rem 0 4rem;
  transition: background 0.35s;
}

.container {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.cookies-header {
  text-align: center;
  margin-bottom: 3rem;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  color: var(--accent);
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.35rem 0.9rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
}

.cookies-title {
  font-size: clamp(1.8rem, 4vw, 3rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 1.15;
  color: var(--text);
  margin-bottom: 1rem;
  transition: color 0.35s;
}

.cookies-meta {
  font-size: 0.85rem;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  transition: color 0.35s;
}

.cookies-meta i { color: var(--accent); }
.dot { opacity: 0.4; }

.cookies-intro {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.7;
  max-width: 640px;
  margin: 0 auto;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1rem;
  padding: 1.25rem 1.5rem;
  transition: background 0.35s, border-color 0.35s, color 0.35s;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2.5rem;
}

.section-card {
  display: flex;
  gap: 1.5rem;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1.25rem;
  padding: 1.75rem;
  transition: background 0.35s, border-color 0.35s;
}

.section-card--last {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent), 0 4px 24px var(--accent-glow);
}

.section-icon {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--accent);
  transition: background 0.35s, border-color 0.35s;
}

.section-body { flex: 1; min-width: 0; }

.section-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 0.75rem;
  letter-spacing: -0.02em;
  transition: color 0.35s;
}

.section-body > p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.7;
  margin-bottom: 0.75rem;
  transition: color 0.35s;
}

.section-body > p:last-child { margin-bottom: 0; }

/* ══ CHECK LIST ══ */
.check-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.check-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
  transition: color 0.35s;
}

.check-list li i { color: var(--accent); font-size: 0.95rem; flex-shrink: 0; margin-top: 0.15rem; }
.check-list li span { flex: 1; }

/* ══ TYPE CARDS ══ */
.type-cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.type-card {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  background: var(--bg);
  border: 1px solid var(--border-soft);
  border-radius: 0.75rem;
  padding: 0.9rem 1rem;
  transition: background 0.35s, border-color 0.35s;
}

.type-icon {
  flex-shrink: 0;
  width: 2.2rem;
  height: 2.2rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: var(--accent);
  transition: background 0.35s, border-color 0.35s;
}

.type-card strong {
  display: block;
  font-size: 0.88rem;
  color: var(--text);
  margin-bottom: 0.2rem;
  transition: color 0.35s;
}

.type-card p {
  font-size: 0.83rem;
  color: var(--text-muted);
  line-height: 1.5;
  margin: 0;
  transition: color 0.35s;
}

/* ══ CHANNELS ══ */
.channels {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.75rem;
}

.channel-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  color: var(--accent);
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.35rem 0.85rem;
  border-radius: 9999px;
  text-decoration: none;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.channel-pill:hover {
  background: var(--accent);
  color: var(--accent-text);
  border-color: var(--accent);
}

/* ══ FOOTER NOTE ══ */
.cookies-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: var(--text-muted);
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-light);
  transition: color 0.35s, border-color 0.35s;
}

.cookies-footer i { color: var(--accent); }

/* ══ RESPONSIVE ══ */
@media (max-width: 640px) {
  .cookies { padding: 3rem 0 2rem; }
  .container { padding: 0 1rem; }

  .section-card {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
    text-align: center;
  }

  .section-body { text-align: center; }
  .check-list { text-align: left; }
  .check-list li { display: block; padding-left: 1.5rem; position: relative; }
  .check-list li i { position: absolute; left: 0; top: 0.2rem; }
  .type-card { flex-direction: column; align-items: center; text-align: center; }
  .channels { justify-content: center; }
  .cookies-footer { text-align: center; }

  .section-icon { width: 2.5rem; height: 2.5rem; font-size: 1.1rem; align-self: center; }
  .type-icon { align-self: center; }
  .cookies-title { font-size: clamp(1.5rem, 7vw, 1.8rem); }
  .cookies-intro { padding: 1rem; font-size: 0.88rem; }
  .channels { gap: 0.4rem; }
  .channel-pill { font-size: 0.76rem; }
}

/* ══ PANTALLAS GRANDES ══ */
@media (min-width: 1400px) {
  .container { max-width: 1100px; }
}

@media (min-width: 1920px) {
  .container { max-width: 1300px; }
}

@media (min-width: 2560px) {
  .container { max-width: 1600px; }
}
</style>